import axios from 'axios'
import { api} from '../../utils/variables'
// define base url
const baseUrl = api


// define axios instance with base url and auth token
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('authToken')}`
  }
})

export const createGroup = async ({ item_id, tag_name, tag_type = 'KEYWORD' }) => {
  try {
    const response = await axiosInstance.post('/tracker/tags.keywords/', {
      item_id,
      tag_name,
      tag_type,
    })

    return response.data
  } catch (error) {
    console.error('Error creating keyword group:', error.response?.data || error.message)
    throw error
  }
}
